import { render, staticRenderFns } from "./ModalWithTitleBar.vue?vue&type=template&id=4c589f28&scoped=true&"
import script from "./ModalWithTitleBar.vue?vue&type=script&lang=js&"
export * from "./ModalWithTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithTitleBar.vue?vue&type=style&index=0&id=4c589f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c589f28",
  null
  
)

export default component.exports